<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>   
    <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
    <div class="main-wrapper" :class="{'blur-content': this.isLoading}">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->
 

      <div class="page-wrapper">

        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                
                 <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6 class="card-title mb-0 float-start" style="padding-left:25px"> {{ $t("customer_create") }}</h6>
                   <button
                        class="btn btn-default btn-sm float-end"
                        @click="resetForm"
                        type="button"
                      >
                      <i class="link-icon" data-feather="repeat"></i>
                        {{ $t("resetFormTxt") }}
                      </button>

                </div>
                <div class="card-body">
              

                    <form
                        class="forms-sample"
                        @submit.prevent="submitData"
                        method="POST"
                    >
                    
 
 
 
                    <div class="row mb-2">

                        <div class="col-lg-6">

                            <label for="defaultconfig" class="col-form-label required">{{  $t('type')  }}</label>


                            <v-select :options="fetchCustomerType" v-model="customerType" label="label" return-object @input="(country) => updateType(country)">
                              <template slot="option" slot-scope="option">
                                    {{option.label}}
                                </template>
                            </v-select>

                            <div v-if="errors.type">
                                <div v-for="error in errors.type" :key="error" class="alert alert-primary" role="alert">
                                    <i data-feather="alert-circle"></i> {{ error }}
                                </div>
                            </div>

                        </div>

                        <div class="col-lg-6">

                            <label for="defaultconfig" class="col-form-label required">{{  $t('name')  }}</label>

                            <input type="text" class="form-control" :id="this.$dynamicId()" :placeholder="$t('name')" @input="forceUpper($event, forms, 'name')" v-model="forms.name"  maxlength="255" required/>

                            <div v-if="errors.name">
                                <div v-for="error in errors.name" :key="error" class="alert alert-primary" role="alert">
                                    <i data-feather="alert-circle"></i> {{ error }}
                                </div>
                            </div>

                        </div>

                        <div class="col-lg-6">

                            <label for="defaultconfig" class="col-form-label">{{  $t('address')  }}</label>

                            <textarea required class="form-control" :id="this.$dynamicId()" :placeholder="$t('address')" @input="forceUpper($event, forms, 'address')" v-model="forms.address" rows="3"></textarea>


                            <div v-if="errors.address">
                                <div v-for="error in errors.address" :key="error" class="alert alert-primary" role="alert">
                                    <i data-feather="alert-circle"></i> {{ error }}
                                </div>
                            </div>

                        </div>
 

                        <div class="col-lg-6">

                            <label for="defaultconfig" class="col-form-label">{{  $t('countryTxt')  }}</label>

                            <v-select :options="fetchkodeNegara" v-model="kodeNegara" label="label"  return-object @input="(country) => updateNegara(country)">
                                <template slot="option" slot-scope="option">
                                    {{ option.label }}
                                </template>
                            </v-select>
                           

                            <div v-if="errors.country">
                                <div v-for="error in errors.country" :key="error" class="alert alert-primary" role="alert">
                                    <i data-feather="alert-circle"></i> {{ error }}
                                </div>
                            </div>

                        </div>


                        <div class="col-lg-6">

                            <label for="defaultconfig" class="col-form-label">{{  $t('tipe_identitas')  }}</label>

                            <v-select :options="fetchkodeJenisIdentitas" v-model="kodeJenisIdentitas" label="label"  return-object @input="(country) => updateIdentitas(country)">
                                <template slot="option" slot-scope="option">
                                    {{ option.label }}
                                </template>
                            </v-select>
                           

                            <div v-if="errors.country">
                                <div v-for="error in errors.country" :key="error" class="alert alert-primary" role="alert">
                                    <i data-feather="alert-circle"></i> {{ error }}
                                </div>
                            </div>

                        </div>
 

    

                        <div class="col-lg-6">

                            <label for="defaultconfig" class="col-form-label">{{  $t('identity_number')  }}</label>

                            <input type="text" class="form-control" :id="this.$dynamicId()" :placeholder="$t('identity_number')" @keypress="isNumber($event)" v-model="forms.identity_number" maxlength="20" > 
                                                   

                            <div v-if="errors.identity_number">
                                <div v-for="error in errors.identity_number" :key="error" class="alert alert-primary" role="alert">
                                    <i data-feather="alert-circle"></i> {{ error }}
                                </div>
                            </div>

                        </div>


                        <div class="col-lg-6">

                            <label for="defaultconfig" class="col-form-label">{{  $t('type_api')  }}</label>

                            <v-select :options="fetchkodeJenisApi" v-model="kodeJenisApi" label="label"  return-object @input="(country) => updateJenisApi(country)">
                                <template slot="option" slot-scope="option">
                                    {{ option.label }}
                                </template>
                            </v-select>
                           

                            <div v-if="errors.country">
                                <div v-for="error in errors.country" :key="error" class="alert alert-primary" role="alert">
                                    <i data-feather="alert-circle"></i> {{ error }}
                                </div>
                            </div>

                        </div>



                        <div class="col-lg-6">

                            <label for="defaultconfig" class="col-form-label">{{  $t('nib')  }}</label>

                            <input type="text" class="form-control" :id="this.$dynamicId()" :placeholder="$t('nib')" @keypress="isNumber($event)" v-model="forms.nib" maxlength="20" > 
                                                   

                            <div v-if="errors.nib">
                                <div v-for="error in errors.nib" :key="error" class="alert alert-primary" role="alert">
                                    <i data-feather="alert-circle"></i> {{ error }}
                                </div>
                            </div>

                        </div>



                        <div class="col-lg-6">

                            <label for="defaultconfig" class="col-form-label">{{  $t('statusTxt')  }}</label>

                            <v-select :options="fetchStatus" v-model="kodeStatus" label="code"  return-object @input="(country) => updateStatus(country)">
                                <template slot="option" slot-scope="option">
                                    {{ option.code }}
                                </template>
                            </v-select>
                           

                            <div v-if="errors.status">
                                <div v-for="error in errors.status" :key="error" class="alert alert-primary" role="alert">
                                    <i data-feather="alert-circle"></i> {{ error }}
                                </div>
                            </div>

                        </div>



                    </div>

 

                    







                   
                    <div class="card-footer">
                      <button
                        class="
                          btn btn-warning
                          text-black
                          fw-bolder
                          btn-icon-text
                        "
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>

                      &nbsp;&nbsp;&nbsp;
                      <button class="btn btn-primary float-end btn-sm" type="submit">
                           <i class="link-icon" data-feather="save"></i>
                        {{ $t("save_change_txt") }}
                      </button>

                       
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>
  
  
<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
 

export default {
    name: "CeisaMasterCustomerCreate",
    props: {},
    components: {

        "navbar-component": navbarComponent,
        "footer-component": footerComponent,

    },
    data() {
        const startDate = new Date();// new Date();
        const endDate = new Date();

        return {
                
            dateFilter: {
                startDate,
                endDate,
            },
            asnType: [],
            fetchAsnType: [],
            trackingOrderStatus: [],

            expectedShipmentTime1dateFilter: {
                startDate,
                endDate,
            },

            showModalNow: false,

            opens: "center",
            locale: {
                format: "yyyy-mm-dd H:MM:ss",
            },

            localeDetail: {
                format: "yyyy-mm-dd",
            },

            highlighted: {

                dates: [ // Highlight an array of dates
                new Date(),
                ],

            },

            digit: {
                decimal: ',',
                thousands: '.',
                prefix: ' ',
                suffix: '',
                precision: 5,
                masked: false
            },
            fetchkodeJenisApi:[],
            fetchkodeJenisIdentitas:[],
            fetchkodeNegara:[],
            fetchStockCondition: [],
            detailAsn: [],
            orderType: '',
            fetchOrderType: [],
            shelfLifeUnit: {},
            shelfLifeType: {},
            permision_role: [],
            isLoading: false,
            maxToasts: 100,
            position: "up right",
            closeBtn: true,
            errors: [],
            userData: "",
            userRole: "",
            companyCode: "",
            fetchStatus: [],
            fetchmultiWhFlag: ['Y', 'N'],
            fetchCustomer: [],
            fetchFulfillment: [],
            customer: "",
            fulfillment: "",
            fetchShelfLifeType: [],
            fetchShelfLifeUnit: [],
            fetchSku: [],
            activeFlag: false,
            shelfLifeFlag: false,
            kitFlag: false,
            freePickGift: false,
            isLoadingStatus: false,
            customerType: {code:"" , name:"" , label:""},
            fetchCustomerType: [],
            forms: {
                customer_id:"",
                type:"",
                type_name:"",
                name:"",
                address:"",
                country:"",
                country_code:"",
                identity_number:"",
                nib:"",
                status:"",
                created_by:"",
                updated_by:"",
                created_at:"",
                updated_at:"",
                type_api:"",
                type_api_name:"",
                type_identity:"",
                type_identity_name:"",
            },
            dataAutocompleteDropdownCountry:[],
            showAutocompleteDropdownCountry:false,
            dataAutocompleteDropdownCountryCode:[],
            showAutocompleteDropdownCountryCode:false,
            kodeJenisApi:{code:"" , name:"", label:""},
            kodeJenisIdentitas:{code:"" , name:"", label:""},
            kodeNegara:{code:"" , name:"", label:""},
            kodeStatus:{code:""},
        };
    },
    watch: {},
    methods: {

        updateType(data){

            this.forms.type        = data.code
            this.forms.type_name   = data.name

        },

        updateStatus(data){

            this.forms.status        = data.code
            
        },

        updateJenisApi(data){

            this.forms.type_api        = data.code
            this.forms.type_api_name   = data.name
            
        },

        updateIdentitas(data){

            this.forms.type_identity        = data.code
            this.forms.type_identity_name   = data.name
            
        },

        asyncStatus(){

            this.fetchStatus = [];
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?type=statusImportir&status=ACTIVE&sort_field=code&sort_type=ASC&limit=3";

            return this.$http
                .get(
                baseURI, { timeout: 10000 }
                )
                .then((response) => {

                    this.fetchStatus = response.data.datas.data;
                 
                }).catch(error => {

                if (error.code == "ECONNABORTED") {
                    this.error("Please Check Your Internet Connection");
                }

            });

        },

        asyncJenisApi(){

            this.fetchkodeJenisApi = [];
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?type=kodeJenisApi&status=ACTIVE&sort_field=code&sort_type=ASC&limit=2";

            return this.$http
                .get(
                baseURI, { timeout: 10000 }
                )
                .then((response) => {

                    var models = response.data.datas.data;

                    if(models.length > 0){

                        for (var x = 0; x < models.length; x++) {

                            var ob = models[x];
                            var md  = {code: ob.code , name: ob.name , label: ob.code +" - "+ ob.name}
                            this.fetchkodeJenisApi.push(md);
                        }

                    }

                
                }).catch(error => {

                if (error.code == "ECONNABORTED") {
                    this.error("Please Check Your Internet Connection");
                }

            });

        },

        asyncIdentitas(){

            this.fetchkodeJenisIdentitas = [];
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?type=kodeJenisIdentitas&status=ACTIVE&sort_field=code&sort_type=ASC&limit=15";

            return this.$http
                .get(
                baseURI, { timeout: 10000 }
                )
                .then((response) => {

                    var models = response.data.datas.data;

                    if(models.length > 0){

                        for (var x = 0; x < models.length; x++) {

                            var ob = models[x];
                            var md  = {code: ob.code , name: ob.name , label: ob.code +" - "+ ob.name}
                            this.fetchkodeJenisIdentitas.push(md);
                        }

                    }

                
                }).catch(error => {

                if (error.code == "ECONNABORTED") {
                    this.error("Please Check Your Internet Connection");
                }

            });

        },


        asynckodeNegara(){

            this.fetchkodeNegara = [];
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?type=kodeNegara&status=ACTIVE&sort_field=code&sort_type=ASC&limit=500";

            return this.$http
                .get(
                baseURI, { timeout: 10000 }
                )
                .then((response) => {

                    var models = response.data.datas.data;

                    if(models.length > 0){

                        for (var x = 0; x < models.length; x++) {

                            var ob = models[x];
                            var md  = {code: ob.code , name: ob.name , label: ob.code +" - "+ ob.name}
                            this.fetchkodeNegara.push(md);
                        }

                    }

                
                }).catch(error => {

                if (error.code == "ECONNABORTED") {
                    this.error("Please Check Your Internet Connection");
                }

            });

        },

        updateNegara(data){

            this.forms.country_code     = data.code
            this.forms.country          = data.name
            
        },

        isNumber(evt){
            const keysAllowed   = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
            const keyPressed    = evt.key;
            
            if (!keysAllowed.includes(keyPressed)) {
                evt.preventDefault()
            }
        },

        selectCountryCodeDropdown(datas){
            this.forms.country                          = datas.name
            this.forms.country_code                     = datas.code
            this.showAutocompleteDropdownCountryCode    = false;
            this.dataAutocompleteDropdownCountryCode    = [];
        },

        handleAutocompleteDropdownCountryCode(){

            const baseURI               = this.$settings.endPointCeisa + "v1/system-code/index";
            var country_code            = this.forms.country_code

            if(country_code.length > 0){
                    return this.$http
                        .get(
                            baseURI + `?per_page=10&page=1&type=kodeNegara&code=${country_code}` , 
                            {
                                timeout: 10000
                            }
                        ).then((response) => {  
                            
                            this.showAutocompleteDropdownCountryCode = true;
                            this.dataAutocompleteDropdownCountryCode = response.data.datas.data;


                        });

                }


        },

        selectCountryDropdown(datas){
            this.forms.country                    = datas.name
            this.forms.country_code               = datas.code
            this.showAutocompleteDropdownCountry   = false;
            this.dataAutocompleteDropdownCountry   = [];
        },


        handleAutocompleteDropdownCountry(){

            const baseURI               = this.$settings.endPointCeisa + "v1/system-code/index";
            var country                 = this.forms.country

            if(country.length > 0){
                    return this.$http
                        .get(
                            baseURI + `?per_page=10&page=1&type=kodeNegara&name=${country}` , 
                            {
                                timeout: 10000
                            }
                        ).then((response) => {  
                            
                            this.showAutocompleteDropdownCountry = true;
                            this.dataAutocompleteDropdownCountry = response.data.datas.data;


                        });

                }


        },
 
        submitData() {
            this.$swal({
                title: this.$t("areYouSure"),
                text: this.$t('submitFormTxt'),
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes!",
            }).then((result) => {
                if (result.value) {
                        
                    this.isLoading = true;
 
                    this.forms.type = this.customerType.code;
                    
                    const baseURI = this.$settings.endPointCeisa + "v1/customer/store";
                    this.$http.post(baseURI, this.forms, { timeout: 10000 }).then((response) => {
                        
                        this.isLoading = false;
                        this.resetForm();

                        if (response.data.status === 200) {
                            var params = this.$onRandom(response.data.datas.customer_id);
                            window.location.href = "/exim/ceisa/customer/detail/" + params + "?status=200&msg=Successfully";
                        } else {
                            this.errors = response.data.errors;
                            this.resultError(response.data.errors);
                        }

                    }).catch((error) => {

                        this.isLoading = false;

                        if (error.code == "ECONNABORTED") {
                            this.error(this.$t("check_internet_connection_txt"));

                        } else {


                            if (error.code == "ECONNABORTED") {
                                
                                this.error(this.$t("check_internet_connection_txt"));

                            } else {

                                if (error.response) {
                                    if (error.response.status === 422) {
                                    this.errors = error.response.data.errors;
                                    this.resultError(error.response.data.errors);
                                    } else if (error.response.status === 401) {
                                    this.logout();
                                    } else if (error.response.status === 403) {
                                    this.$router.push("/authorized-error");
                                    } else if (error.response.status === 500) {
                                    this.$router.push('/server-error');
                                    } else {
                                    this.$router.push('/page-not-found');
                                    }
                                }

                            }

                        }

                    });

                } else {

                    this.isLoading = false;
                }
            });
        },
  
        resetForm() {
            this.errors                 = [];
            this.kodeJenisApi           = {code:"" , name:"" , label:""};
            this.customerType           = {code:"" , name:"" , label:""};
            this.kodeJenisIdentitas     = {code:"" , name:"" , label:""};
            this.kodeNegara             = {code:"" , name:"" , label:""};
            this.kodeStatus             = {code:""};
            this.forms          = {
                customer_id:"",
                type:"",
                type_name:"",
                name:"",
                address:"",
                country:"",
                country_code:"",
                identity_number:"",
                nib:"",
                status:"",
                created_by:"",
                updated_by:"",
                created_at:"",
                updated_at:"",
                type_api:"",
                type_api_name:"",
                type_identity:"",
                type_identity_name:"",
            };
        },

        fetchIt() {
            const userDatas = this.$getUserInfo();
            this.userData = userDatas.sub;
            this.userRole = userDatas.sub.role;
            // this.permision_role = userDatas.sub.permision_role;
            let rolePermision = [];
            userDatas.sub.permision_role.forEach(function (permision) {
                if (permision.permission.controller == 'CeisaCustomerController') {
                    rolePermision = permision;
                }
            });

            if (!rolePermision.method_create) {
                this.$router.push("/authorized-error");
            }

            this.loadCustomerType();
            this.asynckodeNegara();
            this.asyncIdentitas();
            this.asyncJenisApi();
            this.asyncStatus();

            this.permision_role = rolePermision;

        },

        backForm() {
            window.location.href = "/exim/ceisa/customer";
        },

        logout() {

            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

                console.log(response);

            });

            this.$logoutUser();
            window.location.href = '/';
        },

        fade(sType) {
            this.isLoading = sType;
        },

        loading() {
            this.fade(true);
            setTimeout(() => {
                this.fade(false);
            }, 1000); // hide the message after 3 seconds
        },

        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
            }
        },

        success(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "success",
                title: kata,
            });
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },

        loadCustomerType() {

            this.fetchCustomerType = [];

            const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?sort_field=name&sort_type=ASC&type=CUSTOMER_TYPE&status=ACTIVE&limit=10";
            return this.$http
                .get(
                baseURI, { timeout: 10000 }
                )
                .then((response) => {


                    var models = response.data.datas.data;

                    if(models.length > 0){

                        for (var x = 0; x < models.length; x++) {

                            var ob = models[x];
                            var md  = {code: ob.code , name: ob.name , label: ob.code +" - "+ ob.name}
                            this.fetchCustomerType.push(md);
                        }

                    }

 
                }).catch(error => {

                if (error.code == "ECONNABORTED") {
                    this.error("Please Check Your Internet Connection");
                }

            });
        },

        forceUpper (e, obj, prop) {
            const start = e.target.selectionStart
            e.target.value = e.target.value.toUpperCase()
            this.$set(obj, prop, e.target.value)
            e.target.setSelectionRange(start, start)
        },

    },
    events: {},
    created: function () { },
    mounted() {

        this.fetchIt();


    },
};
</script>
<style scoped>.required:after {
  content: " *";
  color: red;
}</style>